var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-5"},[_c('DateSelector',{attrs:{"dates":_vm.dates},on:{"setDates":_vm.setDates}}),_c('LessonsTabs',{staticClass:"mt-10",attrs:{"dates":_vm.dates}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }